import type { BlissBasicOptionCategoryId } from './blissBasicOptionCategories'

export type BlissBasicWizardStep = {
  categoryId: BlissBasicOptionCategoryId
  step: number
  title: string
  subtitle: string
  examples: string
  photos: BlissBasicCatalogPhoto[]
}

/** Public landing catalog shape (API + BlissBasicSite). */
export type BlissBasicCatalogPhoto = {
  id: string
  productId: string | null
  url: string
  title: string | null
  description: string | null
  focalPoint: string | null
  priceUsd: number | null
  width: number | null
  height: number | null
  isHero: boolean
  sortOrder: number
  /** Wizard step; null = gallery/hero only */
  optionCategory: BlissBasicOptionCategoryId | null
  inStock: boolean
  active: boolean
}

export type BlissBasicCatalogProduct = {
  id: string
  name: string
  description: string | null
  priceUsd: number | null
  priceLabel: string | null
  sortOrder: number
  photoIds: string[]
}

export type BlissBasicLandingSettings = {
  startingPricePrefix: string
  startingPriceUsd: number
  investmentNote: string
}

export type BlissBasicConfiguratorChoice = {
  choiceKey: string
  label: string
  detail: string | null
  priceUsd: number | null
  priceHighUsd: number | null
  priceLabel: string | null
  photoUrl: string | null
  active?: boolean
  inStock?: boolean
}

export type BlissBasicConfiguratorStepDef = {
  id: string
  title: string
  subtitle: string
  multiSelect: boolean
  kind: 'choices' | 'sleepers' | 'timeline'
  items: BlissBasicConfiguratorChoice[]
}

export type BlissBasicConfiguratorStepCopy = Partial<
  Record<string, { title?: string; subtitle?: string }>
>

export type BlissBasicPublicCatalog = {
  tenantSlug: string
  landing: BlissBasicLandingSettings
  heroPhoto: BlissBasicCatalogPhoto | null
  photos: BlissBasicCatalogPhoto[]
  products: BlissBasicCatalogProduct[]
  optionWizardSteps: BlissBasicWizardStep[]
  configuratorSteps?: BlissBasicConfiguratorStepDef[]
  configuratorStepCopy?: BlissBasicConfiguratorStepCopy
}

export const BLISS_BASIC_CATALOG_API = '/api/bliss-basic-catalog'
